import { put, select, call, takeLatest } from 'redux-saga/effects';
import { LOAD_MORE_REQUEST } from '../constants';
import * as Selectors from '../selectors';
import { getTrips } from '../../../shared/api/origo';
import { loadMoreSuccessAction, updateQuery } from '../actions';
import { getGTMShowMoreEvent } from '../../utils/gtmEvents';

function isPositiveInteger(n) {
  return Number.isInteger(n) && n > 0;
}

export function* fetchMoreRequest() {
  const hasMore = yield select(Selectors.hasMoreFlights);
  if (!hasMore) {
    // abort
    return;
  }

  const lastCursor = yield select(Selectors.getLastCursor);
  const settings = yield select(Selectors.getSettings);
  const query = yield select(Selectors.getCurrentFilterParams);

  try {
    const result = yield call(getTrips, settings, { ...query, after: lastCursor });

    let pageQuery =
      query.page && isPositiveInteger(parseInt(query.page, 10)) ? parseInt(query.page, 10) : 1;
    pageQuery += 1;

    yield put(updateQuery({ page: pageQuery }, getGTMShowMoreEvent()));
    yield put(loadMoreSuccessAction({ ...result }));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to fetch more lms departures, call got error ');
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* fetchMoreRequestSaga() {
  yield takeLatest([LOAD_MORE_REQUEST], fetchMoreRequest);
}
